module.exports = __webpack_public_path__ + "static/media/verybad.15a34c24.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/emojis/verybad.gif
// module id = 170
// module chunks = 0